import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { FC } from 'react';
import { SidebarProps } from '../../../lib/types/types';

const SideBars: FC<SidebarProps> = ({ sidebars, activeSideBarButton, toggleSideBarButton }) => {
	return (
		<>
			{/*
			 * Vertical Tabs Navigation for Tablets and Desktop
			 */}
			<Box sx={{ display: { xs: 'none', xl: 'flex' }, margin: '1rem 2rem 1rem 0', minWidth: '16.4rem' }}>
				<Tabs
					orientation='vertical'
					value={activeSideBarButton}
					onChange={toggleSideBarButton}
					sx={{ borderRight: 1, borderColor: 'divider', width: '100%' }}
				>
					{sidebars.map((sidebar, index) => (
						<Tab key={index} icon={sidebar.icon} iconPosition='start' label={sidebar.label} {...a11yProps(index)} />
					))}
				</Tabs>
			</Box>
			{/*
			 * Horizontal Tabs Navigation for Mobiles
			 */}
			<Box sx={{ display: { xs: 'flex', xl: 'none', maxWidth: '-webkit-fill-available' } }}>
				<Tabs
					orientation='horizontal'
					variant='scrollable'
					scrollButtons
					allowScrollButtonsMobile
					aria-label='scrollable auto tabs example'
					value={activeSideBarButton}
					onChange={toggleSideBarButton}
					sx={{ borderBottom: 1, borderColor: 'divider' }}
				>
					{sidebars.map((sidebar, index) => (
						<Tab key={index} label={sidebar.label} {...a11yProps(index)} />
					))}
				</Tabs>
			</Box>
		</>
	);
};
export default SideBars;

function a11yProps(index: number) {
	return {
		id: `vertical-tab-${index}`,
		'aria-controls': `vertical-tabpanel-${index}`,
	};
}
